import { Actions, ActionId } from '../../../util/RequestAction';

export const roleListThunks = Actions('roles', 'list');
export const roleListActionIds = ActionId('roles', 'list');